import React from 'react';
import cn from 'classnames';

import ExternalLink from 'components/generic/ExternalLink.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './DeviceRequirements.module.scss';

const LINK = 'https://help.getslick.com/en/articles/11162265-how-to-find-your-device-specs';

const DeviceRequirements = ({ device, model, processor, ram }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="DeviceRequirements"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.title}>
        <div className={CN.iconContainer}>
          <Icon variant="deviceTablet" width="xl" />
        </div>
        {t('staffAndBusiness.userNetwork.hardwareInformation.section1Title')}
      </div>
      <div className={CN.text}>
        {t('staffAndBusiness.userNetwork.hardwareInformation.section1Description')}{' '}
        <ExternalLink variant="inline" link={LINK}>
          <div className={CN.link}>{t('staffAndBusiness.userNetwork.hardwareInformation.linkLabel')}</div>
        </ExternalLink>
      </div>
      <div className={CN.info}>
        <div className={CN.box}>
          {t('staffAndBusiness.userNetwork.hardwareInformation.recommendedDevice')}
          <div className={CN.text}>
            {device}
            <br />
            {model}
          </div>
        </div>
        <div className={CN.separator}>{t('common.or').toUpperCase()}</div>
        <div className={CN.box}>
          {t('staffAndBusiness.userNetwork.hardwareInformation.minSpecDevices')}
          <div className={CN.text}>
            {t('staffAndBusiness.userNetwork.hardwareInformation.processor')} {processor}
            <br />
            {t('staffAndBusiness.userNetwork.hardwareInformation.ram')} {ram}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceRequirements;
